import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';

import PersonalDataSection from '../../features/accountSettings/PersonalDataSection';
import PasswordsSection from '../../features/accountSettings/PasswordsSection';
import EmailSection from '../../features/accountSettings/EmailSection';

import SettingsTabulator from '../../components/layouts/SettingsTabulator';

const propTypes = {
    location: PropTypes.object,
    storeCurrentLanguage: PropTypes.string,
    forceRefetch: PropTypes.bool,
    isLoading: PropTypes.bool,
    getExchangeRate: PropTypes.func
};

const AccountSettings = () => {
    const intl = useIntl();
    const translations = intl.messages.accountSettings;

    const refreshTabComponent = tabulatorId => {
        switch(tabulatorId){
            case 'accountSettings-personalData':
                return <PersonalDataSection translations={translations.personalDataTab} />;
            case 'accountSettings-passwords':
                return <PasswordsSection translations={translations.passwordsTab} />;
            case 'accountSettings-email':
                return <EmailSection translations={translations.emailTab} />;
            default:
                return null;
        }
    };

    return (
        <SettingsTabulator
            title={{
                iconClassName: null,
            }}
            tabulatorHeader={{
                label: translations.title,
                iconClassName: 'fa fa-align-justify'
            }}
            refreshTabComponent={refreshTabComponent}
            tabs={[
                {
                    id: 'accountSettings-personalData',
                    header:  {
                        label: translations.personalDataTab.title,
                        iconClassName: 'fa fa-tasks'
                    }
                },
                {
                    id: 'accountSettings-passwords',
                    header:  {
                        label: translations.passwordsTab.title,
                        iconClassName: 'fa fa-key'
                    }
                },
                {
                    id: 'accountSettings-email',
                    header:  {
                        label: translations.emailTab.title,
                        iconClassName: 'fa fa-envelope'
                    }
                },
            ]}
        />
    );
};

AccountSettings.propTypes = propTypes;
AccountSettings.displayName = 'AccountSettings';

const mapStateToProps = () => ({

});

const mapDispatch = {

};

export default connect(mapStateToProps, mapDispatch)(AccountSettings);